import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { FormattedMessage } from 'react-intl';
import slugify from 'dibs-slugify/exports/slugify';
import styles from './styles/AllShoppersmodal.scss';
import get from 'lodash.get';

function AllShoppersModalComponent({ viewer, isOpen, onClose }) {
    return (
        <ModalContainer isOpen={isOpen} onClose={onClose} modalSize="large">
            <ModalCloseButton onClick={onClose} />
            <BarHeader
                title={
                    <FormattedMessage
                        id="AllShoppersModal.title"
                        defaultMessage="Saturday Shopper"
                    />
                }
            />
            <ModalBody>
                {(get(viewer, 'allShoppingWith') || []).map(({ groupName, shoppers }) => (
                    <div key={groupName}>
                        <h3 className={styles.groupTitle}>{groupName}</h3>
                        <ul className={styles.linkContainer}>
                            {(shoppers || []).map(({ name, url }) => {
                                const dataTn = `shopper-${slugify(name)}`;
                                return (
                                    <li className={styles.linkItem} key={url} data-tn={dataTn}>
                                        <a className={styles.link} href={url}>
                                            {name}
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                ))}
            </ModalBody>
        </ModalContainer>
    );
}

AllShoppersModalComponent.propTypes = {
    viewer: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export const AllShoppersModal = createFragmentContainer(AllShoppersModalComponent, {
    viewer: graphql`
        fragment AllShoppersModal_viewer on Viewer {
            allShoppingWith {
                groupName
                shoppers {
                    name
                    url
                }
            }
        }
    `,
});
